import { render, staticRenderFns } from "./Userchoosetool.vue?vue&type=template&id=46487ebc&scoped=true"
import script from "./Userchoosetool.vue?vue&type=script&lang=js"
export * from "./Userchoosetool.vue?vue&type=script&lang=js"
import style0 from "./Userchoosetool.vue?vue&type=style&index=0&id=46487ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46487ebc",
  null
  
)

export default component.exports